module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/axios/index.js
// module id = 31
// module chunks = 0 1 2